import React from 'react';
import { useNavigate } from 'react-router-dom';
import { colors, ACTION_BTN_RADIUS } from '../theme';
import { useLang } from '../i18n/LanguageContext';
import { notFoundText } from '../i18n/pages/notFound';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = notFoundText[lang];

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '40px 24px',
      textAlign: 'center',
    }}>
      <div style={{
        fontSize: 96,
        fontWeight: 800,
        color: colors.brand,
        lineHeight: 1,
        marginBottom: 16,
        letterSpacing: -4,
      }}>
        404
      </div>
      <h1 style={{
        fontSize: 24,
        fontWeight: 700,
        color: colors.textPrimary,
        margin: '0 0 12px',
      }}>
        {t.heading}
      </h1>
      <p style={{
        fontSize: 15,
        color: colors.textMuted,
        margin: '0 0 32px',
        maxWidth: 360,
        lineHeight: 1.6,
      }}>
        {t.description}
      </p>
      <div style={{ display: 'flex', gap: 12 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            height: 38,
            padding: '0 20px',
            background: colors.bgSurface,
            color: colors.textSecondary,
            border: `1px solid ${colors.borderInput}`,
            borderRadius: ACTION_BTN_RADIUS,
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {t.goBack}
        </button>
        <button
          onClick={() => navigate('/')}
          style={{
            height: 38,
            padding: '0 20px',
            background: colors.brand,
            color: '#fff',
            border: 'none',
            borderRadius: ACTION_BTN_RADIUS,
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {t.goHome}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
